import { comparePotentiallyNumbered } from "./util";

export const compareSeasonIds = comparePotentiallyNumbered;
